import { InferOutput, literal, object } from 'valibot'
import { CurrentEDCSSchema } from '../../Current/CurrentEDCS.type'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.River,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: -1,
  water_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const RiverEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.River),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  water_e: EntityElevationSchema,
  current: CurrentEDCSSchema,
  ...HasXYSchema.entries,
})

export type RiverEntity = InferOutput<typeof RiverEntitySchema>

/**
 * Natural flowing watercourse that moves towards an ocean, sea, or another river.
 */
export const RiverEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.River,
  dname: 'River',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 0,
  entDefaults,
}

export function createRiverEntity(id: number, x: number, y: number): RiverEntity {
  return {
    ...entDefaults,
    heading: 0,
    current: {
      edc: 0,
      s: 0,
    },
    id,
    x,
    y,
  }
}
